/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DreampayPaymentV2 {
  securityCode?: string;
  softDescriptor: string;
  posId: string;
  establishmentId?: number;
  establismentName: string;
  purchaseValue?: number;
  totalValueBrl?: number;
  installmentValueBrl?: number;
  paymentMethod?: number;
  installments?: number;
  readMethod?: number;
  cardHolder: string;
  cpFofCardOwner?: string;
  cpfName?: string;
  cardNumber: string;
  cardExpirationDate: string;
  cardType: string;
  exchangeRate?: number;
  orderNumber: string;
  customerName: string;
  paymentLink?: string;
  customerEmail?: string;
  currencyCode?: string;
  customerPhoneNumber?: string;
  customerAddress?: string;
  customerZipCode?: string;
  customerCity?: string;
  customerCountryId?: number;
  customerCpfCNPJ?: string;
  cardProcessingComission?: number;
  pdfUrl?: string;
}
